import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, hasConsented } from '../utils/analytics';

/**
 * Hook to automatically track page views when route changes
 * Only tracks if user has consented to cookies
 */
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if user has consented
    if (hasConsented()) {
      // Track the page view with full path including search params
      const fullPath = location.pathname + location.search;
      trackPageView(fullPath);
    }
  }, [location]);
};

export default usePageTracking;
